<script setup lang="ts">
const slots = useSlots();
</script>

<template>
  <UCard variant="outline" class="bg-bunker-950 ring-0 border border-default" :ui="{ body: 'p-4' }">
    <p v-if="slots.header" class="!my-0 mb-3 flex items-center justify-center gap-2 text-center text-sm font-medium">
      <slot name="header" />
    </p>
    <slot />
  </UCard>
</template>
